import React, { useState, useEffect } from 'react';
import FormCheckbox from '../../form/components/form-checkbox/FormCheckbox/FormCheckbox';

const ActiveRow = ({ val, getHandlers }) => {
    const [active, setActive] = useState(val ? '1' : '0');
    const handlers = getHandlers('change');
    useEffect(() => {
        setActive(val ? '1' : '0');
    }, [val]);
    if (val?.component && React.isValidElement(val?.component)) return val?.component;
    return (
        <>
            {val === 'disabled' ? (
                <div
                    style={{
                        pointerEvents: 'none',
                        opacity: '1',
                        width: '20px',
                        height: '20px',
                        border: `1px solid ${'var(--greyMainColor)'}`,
                        borderRadius: '6px',
                        backgroundColor: 'var(--greySuperLightColor)',
                        marginLeft: '12px'
                    }}
                ></div>
            ) : (
                <FormCheckbox
                    setFormData={() => {}}
                    handlers={handlers}
                    value={active}
                    reload={active}
                    compStyle={{
                        wrapper: {
                            marginBottom: '0px !important',
                            width: 'auto',
                            paddingLeft: '12px'
                        },
                        label: { marginBottom: '0px' }
                    }}
                />
            )}
        </>
    );
};
export default ActiveRow;
